import { getIntegerAsString, getDateAsMoment } from '../../../data/booking/selectors/form';
import isEmpty from "lodash/isEmpty";
import {getRoute} from "../../../data/booking/selectors/booking";
import moment from "moment/moment";

const LMD_DAYS = 4
const LMP_DAYS = 2

function startAt(state){
    const route = getRoute(state)
    return moment().add(route.isLMD ? LMD_DAYS : LMP_DAYS, 'days').toDate()
}

function getDefaultValues() {
    return {
        date: null,
        from: {
            firstInput: null,
            secondInput: null
        },
        hour: null,
        to: {
            firstInput: null,
            secondInput: null
        },
        people: 0,
    };
}

function getEditValues(state) {
    const { entities, editingItem } = state.booking;
    const item = entities.items[editingItem];


    return {
        date: getDateAsMoment(item.date),
        from: {
            firstInput: {
                ...item.from,
                type: 'stop',
                id: item.from.stop.id,
            },
            secondInput: null
        },
        to: {
            firstInput: {
                ...item.to,
                type: 'stop',
                id: item.to.stop.id
            },
            secondInput: null
        },
        people: item.people,
        hour: item.hour
    };
}

function equals(itemA, itemB){
    return getDateAsMoment(itemA.date).format() == getDateAsMoment(itemB.date).format()
        && itemA.people == itemB.people
        && itemA.hour == itemB.hour
        && itemA.from && itemB.from && itemA.from.id == itemB.from.id
        && itemA.to && itemB.to && itemA.to.id == itemB.to.id
}

export {
    getDefaultValues,
    getEditValues,
    equals,
    startAt
};
